// src/hooks/useVehicles.js
import { useEffect, useState } from 'react';
import { getVehicles, updateVehicleDates as apiUpdateVehicleDates } from '../api/vehicles';

export default function useVehicles() {
  const [vehicles, setVehicles] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch from backend
  const refreshVehicles = async () => {
    setLoading(true);
    try {
      const data = await getVehicles();
      setVehicles(data);
    } finally {
      setLoading(false);
    }
  };

  // Update a vehicle's PHV timestamps
  const updateVehicleDates = async (vrm, body) => {
    await apiUpdateVehicleDates(vrm, body);
    await refreshVehicles(); // Keep UI synced
  };

  useEffect(() => {
    refreshVehicles();
  }, []);

  return { vehicles, loading, refreshVehicles, updateVehicleDates };
}
